// extracted by mini-css-extract-plugin
export default {"thumbnail":"styles_thumbnail__cyIFO","header":"styles_header__R+yEH","headerTitle":"styles_headerTitle__7sRQp"};